import Alerts from "@/components/Alerts";
import Button from "@/components/Button";
import PageSkeleton from "./components/PageSkeleton";
import Offerlecture from "./components/Offerlecture";

import useIsOfferOwned from "./hooks/useIsLectureOwned";

function OfferContentPage({ offer, isPending }) {
    const { isOwned } = useIsOfferOwned(offer);
    const grade = offer?.attributes?.grade;
    return (
        <section className="container flex flex-col items-center mx-auto text-sm justify-centerpb-4 md:px-0 md:text-lg">
            <div className="flex items-center justify-between w-full px-10 my-10 text-secondary-color">
                <h2 className="text-2xl md:text-4xl">
                    محتوي <span className="text-secondary-color">العرض </span>
                </h2>

                {!isOwned && (
                    <Button to="/redeem" type="primary" name="pay the product">
                        أشترك الأن
                    </Button>
                )}
            </div>

            <div className="container w-full px-10 my-10 space-y-7">
                {isPending && <PageSkeleton />}
                {!isPending &&
                    offer.relationships?.lectures?.map((item) => (
                        <Offerlecture
                            isOwned={isOwned}
                            lecture={item}
                            key={item.id}
                            grade={grade}
                        />
                    ))}
                {!offer?.relationships?.lecturesCount && !isPending ? (
                    <Alerts
                        variant={"filled"}
                        severity={"error"}
                        message={"لا يوجد كورسات"}
                    />
                ) : null}
            </div>
        </section>
    );
}

export default OfferContentPage;
